import type {
  schemaType,
  paramsType,
  returnType,
} from '~~/shared/api/strapi/escapadas/detail/schema'
import {
  strapiServerFetchWrapper,
  strapiBrowserFetchWrapper,
} from '~~/server/utils/strapi/endpointWrapper'

const endpoint = '/escapadas/detail'

export const serverFetch = (params: paramsType): Promise<returnType> =>
  strapiServerFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  strapiBrowserFetchWrapper<paramsType, schemaType>(endpoint, params)
